import { useMemo, useRef, useState } from "react";

export type DrawerState<T> = {
  visible: boolean;
  data?: T;
};

export type DrawerController<T> = DrawerState<T> & {
  close: () => void;
  open: (data?: T) => void;
  set: (state: DrawerState<T>) => void;
};

export function useDrawer<T>(defaultState?: DrawerState<T>) {
  const [state, setState] = useState<DrawerState<T>>(
    defaultState ?? { visible: false },
  );
  const stateRef = useRef(state);

  return useMemo(
    () =>
      ({
        visible: state.visible,
        data: state.data,
        // get visible() {
        //   return stateRef.current.visible;
        // },
        // get data() {
        //   return stateRef.current.data;
        // },
        close: () => {
          setState({ visible: false });
        },
        open: (data?: T) => {
          setState({ visible: true, data: data ?? stateRef.current.data });
        },
        set: (changes: Partial<DrawerState<T>>) => {
          const newState = { ...stateRef.current, ...changes };
          setState(newState);
        },
      }) as DrawerController<T>,
    [state.visible, state.data],
  );
}
